import LocalStorageService from './LocalStorageService';
import type {
  ITokenService,
  TokensType,
  TokenServiceSetOptionsType,
} from './TokenService';

const TOKEN = 'tokens';

class TokenService implements ITokenService {
  temporalToken: TokensType | null = null;

  async get(): Promise<TokensType | null> {
    // Tokens can be saved in Session storage if the user decided not to use the "remember me" feature
    let res = window.sessionStorage.getItem(TOKEN);

    if (!res) {
      res = await LocalStorageService.getItem(TOKEN);
    }

    return res ? JSON.parse(res) : null;
  }

  async set(
    tokens: TokensType,
    options?: TokenServiceSetOptionsType,
  ) {
    const json = JSON.stringify(tokens);

    if (options?.sessionOnly) {
      return window.sessionStorage.setItem(TOKEN, json);
    }

    return LocalStorageService.setItem(TOKEN, json);
  }

  setTemporal(tokens: TokensType) {
    this.temporalToken = { ...tokens };
  }

  useTemporal() {
    if (this.temporalToken) {
      this.set(this.temporalToken);
    }

    this.temporalToken = null;
  }

  clear() {
    window.sessionStorage.removeItem(TOKEN);
    return LocalStorageService.removeItem(TOKEN);
  }

  isRememberMe() {
    if (window.sessionStorage.getItem(TOKEN)) {
      return false;
    }
    return true;
  }
}

export default new TokenService();
